import { siteRoutes } from "@/routes/siteRoutesList";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Box, Button, Heading, Text } from "@radix-ui/themes";

export const SingleChallenge404 = ({ navigate }: any) => {
  // Page Document Title
  useDocumentTitle(`404 - Challenge not found`);

  return (
    <Box>
      <Heading as="h1">Challenge not found</Heading>
      <Text as="p">
        This challenge has most likely been removed or the creator is no longer
        active
      </Text>
      <Button onClick={() => navigate(siteRoutes["challenges"])}>
        Back to challenges
      </Button>
    </Box>
  );
};
